//Redux
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//Components
import { IoMdClose } from "react-icons/io";
import "./style.css";
import { setComponentActive } from "../../reducers/userConfigSlice";
import { ClientDetails, NoImage, parseDate } from "@delibrandev/utils";
import { getOrderDetails } from "../../api/orders";
import { ProductSelections } from "./productSelections";
import { externalIntegrationsEnabled } from "../../utils/deliveryAddress";

export const OrderDetails = () => {
  const dispatch = useDispatch();
  const selectedOrder = useSelector((state) => state.aplicationConfig.userConfig.order);
  const lastComponentActive = useSelector((state) => state.aplicationConfig.userConfig.lastComponentActive);

  const [details, setDetails] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const orderId = selectedOrder?.orderId;
  const order = details?.orderId === orderId ? details : null;

  useEffect(() => {
    let active = true;
    setDetails(null);
    setError(false);
    if (!orderId) { setError(true); return; }
    getOrderDetails(orderId).then(response => {
      if (!active) return;
      if (response?.error === false && response.data?.orderId === orderId && Array.isArray(response.data.products)) {
        setDetails(response.data);
      } else { setError(true); }
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [orderId, attempt]);

  const totalProducts = order?.products?.reduce((acc, product) => acc + product.quantity, 0) || 0;

  const handleMenu = (component) => {
    dispatch(setComponentActive("" + component));
  };

  const Product = ({ data }) => {
    const [imageFailed, setImageFailed] = useState(false);
    const image = Array.isArray(data.images) ? data.images.find(value => typeof value === "string" && value.trim()) : null;
    return (
      <div className="productItem">
        {image && !imageFailed ? (
          <img className="productItem-image" src={image} alt={data.name} onError={() => setImageFailed(true)} />
        ) : (
          <div className="productItem-image productItem-image-placeholder" role="img" aria-label={`Sin imagen de ${data.name}`}><NoImage /></div>
        )}
        <div className="productItem-details">
          <div className="productItem-details-block1">
            <div className="productItem-name">{data.name}</div>
            <ProductSelections data={data} />
          </div>
          <div className="productItem-details-block2">
            <div className="productItem-info">
              <div className="productItem-price">{data.unitPriceWithTax ?? "—"} € · IVA incluido</div>
              <div className="productItem-quantity">{data.quantity}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const InvoiceResume = () => {
    return (
      <div>
        <div className="invoiceResume-Body">
          <div className="invoiceResume-Item">
            <div className="invoiceResume-title">Subtotal sin IVA</div>
            <div className="invoiceResume-note">{totalProducts} artículos</div>
            <div className="invoiceResume-value">{order?.amounts?.subtotal ?? "Pendiente de revisión"}€</div>
          </div>
          <div className="invoiceResume-Item">
            <div className="invoiceResume-title">Domicilio</div>
            <div className="invoiceResume-note"></div>
            <div className="invoiceResume-value">{order?.amounts?.shipping ?? "—"} €</div>
          </div>
          <div className="invoiceResume-Item">
            <div className="invoiceResume-title">Descuento</div>
            <div className="invoiceResume-note"></div>
            <div className="invoiceResume-value">{order?.amounts?.discounts ?? "—"}€</div>
          </div>
          <div className="invoiceResume-Item"><div className="invoiceResume-title">Impuestos</div><div></div><div className="invoiceResume-value">{order?.amounts?.tax ?? "—"} €</div></div>
          <div className="invoiceResume-Separator"></div>
          <div className="invoiceResume-Item">
            <div className="invoiceResume-title">Total</div>
            <div></div>
            <div className="invoiceResume-value">{order?.amounts?.total ?? "Pendiente de revisión"}€</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="order-details">
      <div className="order-details-header">
        <div className="order-details-date">{parseDate(order?.updatedAt || selectedOrder?.updatedAt)}</div>
        <button type="button" aria-label="Cerrar detalles y volver a entregas" className="order-details-close" onClick={() => handleMenu(lastComponentActive)}><IoMdClose size="2rem" aria-hidden="true" /></button>
      </div>
      <div className="order-details-title">Detalles del pedido</div>

      {!order ? <div className="containerBlock">
        {error ? <><p role="alert">No se han podido cargar los detalles del pedido. Comprueba tu acceso y vuelve a intentarlo.</p><button type="button" onClick={() => setAttempt(value => value + 1)}>Reintentar</button></> : <p role="status">Cargando detalles del pedido…</p>}
      </div> : <>
      <div className="containerBlock">
        <div className="order-details-titleBlock">Productos del pedido</div>

        <div className="order-details-list">
          {order?.products?.map((product, index) => (
            <Product key={index} data={product} />
          ))}
        </div>
      </div>

      <div className="containerBlock">
        <div className="order-details-titleBlock">Total</div>
        <InvoiceResume />
      </div>

      <div className="containerBlock">{order && <><ClientDetails data={order} size={externalIntegrationsEnabled ? "normal" : "small"} />{!externalIntegrationsEnabled && <p className="local-map-status">El mapa no está disponible en este entorno.</p>}</>}</div>

      <div className="containerBlock">
        <div className="order-details-titleBlock">Notas</div>
        <div className="order-details-notes">{order?.notes?.length > 0 ? order?.notes : "Sin notas del pedido"}</div>
      </div>
      </>}
    </div>
  );
};
